import { BaseQuestionPreview } from '../base-question';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { Space } from 'antd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CorrectAnswerContainer = styled.div.withConfig({
  displayName: "previewcomponent__CorrectAnswerContainer",
  componentId: "sc-zbfc7x-0"
})(["flex:1;color:", ";"], styleVariables.colors.gray11);
var CorrectAnswerNumber = styled.span.withConfig({
  displayName: "previewcomponent__CorrectAnswerNumber",
  componentId: "sc-zbfc7x-1"
})(["margin-right:8px;&:nth-child(2){width:85%;}&:nth-child(3){width:10%;display:flex;justify-content:flex-end;}"]);
export var FillInBlankPreview = function FillInBlankPreview(props) {
  var question = props.question,
      questionIndex = props.index,
      active = props.active;
  return /*#__PURE__*/_jsx(BaseQuestionPreview, {
    question: question,
    index: questionIndex,
    active: active,
    children: /*#__PURE__*/_jsx(Space, {
      direction: "vertical",
      size: "middle",
      children: question.answers.map(function (answer, index) {
        return /*#__PURE__*/_jsxs(CorrectAnswerContainer, {
          children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: ["(", index + 1, ")"]
          }), answer.description]
        }, index);
      })
    })
  });
};